import { render, staticRenderFns } from "./VSlider.vue?vue&type=template&id=80fa4550&"
import script from "./VSlider.vue?vue&type=script&lang=js&"
export * from "./VSlider.vue?vue&type=script&lang=js&"
import style0 from "./VSlider.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports